import React from 'react';

// Shared search input used on the list pages and admin tables. Renders the
// magnifying-glass affordance on the left, a green border, and a clear (×)
// button on the right that appears whenever the field has content.
//
// Props:
//   value       — controlled string value
//   onChange    — called with the new string (NOT the event) so callers can
//                 wire it directly to a setState setter
//   placeholder — placeholder text
//   className   — applied to the outer wrapper (use this for flex-1, min-w, etc.)
export default function SearchInput({ value, onChange, placeholder, className = '' }) {
  return (
    <div className={`relative ${className}`}>
      <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-fusion-forest pointer-events-none" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full bg-white border border-[#DADCCD] rounded-xl text-ink pl-10 pr-9 py-2 font-['Metropolis'] text-sm focus:outline-none focus:border-[#92D400] transition-colors" />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Clear search"
          className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-[#51534A] hover:text-[#E0290A] transition-colors">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </div>
  );
}
